import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, Transition as _Transition, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex" }
const _hoisted_2 = { class: "absolute right-0 top-0 flex w-16 justify-center pt-5" }
const _hoisted_3 = { class: "flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 ring-1 ring-white/10" }
const _hoisted_4 = { class: "flex h-16 shrink-0 items-center" }
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-1 gap-y-3 h-3/4"
}
const _hoisted_6 = {
  disabled: "",
  class: "text-lg py-2 px-5 border font-regular rounded-lg bg-stone-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-opacity-50 flex items-center justify-center w-full h-[2.5em] text-stone-200 cursor-not-allowed"
}
const _hoisted_7 = { class: "space-y-0.5" }
const _hoisted_8 = { class: "inline-block text-xs px-3 uppercase text-darkGray-4" }
const _hoisted_9 = {
  key: 0,
  class: "fas fa-exclamation-triangle text-xs ml-1 hover:text-orange-4",
  title: "Du har inte behörighet till kategori"
}
const _hoisted_10 = { class: "flex flex-col py-1.5 gap-2" }
const _hoisted_11 = { class: "flex items-center justify-start" }
const _hoisted_12 = { class: "flex items-center justify-center flex-shrink-0 w-6 h-6" }
const _hoisted_13 = { class: "inline-block ml-3 text-sm truncate" }
const _hoisted_14 = { class: "relative mt-auto py-1.5 space-y-2" }
const _hoisted_15 = { class: "flex items-center transition rounded-lg group shrink-0" }
const _hoisted_16 = {
  key: 0,
  class: "ml-2 text-xs text-left sm:block truncate"
}
const _hoisted_17 = { class: "block font-medium truncate" }
const _hoisted_18 = { class: "text-darkGray-4" }
const _hoisted_19 = { class: "ml-auto flex items-center text-gray-600" }
const _hoisted_20 = { class: "hidden xl:fixed xl:inset-y-0 xl:z-50 xl:flex xl:w-72 xl:flex-col" }
const _hoisted_21 = { class: "flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 ring-1 ring-white/5" }
const _hoisted_22 = { class: "flex h-16 shrink-0 items-center justify-between" }
const _hoisted_23 = {
  key: 0,
  class: "flex flex-1 flex-col"
}
const _hoisted_24 = {
  disabled: "",
  class: "text-lg py-2 px-5 mb-[1em] border font-regular rounded-lg bg-stone-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-opacity-50 flex items-center justify-center w-full h-[2.5em] text-stone-200 cursor-not-allowed"
}
const _hoisted_25 = { class: "space-y-0.5" }
const _hoisted_26 = { class: "inline-block text-xs px-3 uppercase text-darkGray-4" }
const _hoisted_27 = {
  key: 0,
  class: "fas fa-exclamation-triangle text-xs ml-1 text-orange-4 text-opacity-50 hover:text-orange-4",
  title: "Du har inte behörighet till den här kategorin"
}
const _hoisted_28 = { class: "flex flex-col py-1.5 gap-2 pb-4" }
const _hoisted_29 = { class: "flex items-center justify-start" }
const _hoisted_30 = { class: "flex items-center justify-center flex-shrink-0 w-6 h-6" }
const _hoisted_31 = { class: "inline-block ml-3 text-sm truncate" }
const _hoisted_32 = { class: "xl:pl-72" }
const _hoisted_33 = { class: "sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-6 border-b border-white/5 bg-white px-4 shadow-sm sm:px-6 lg:px-8" }
const _hoisted_34 = { class: "block w-full" }
const _hoisted_35 = {
  key: 0,
  class: "inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 truncate sm:min-w-max"
}
const _hoisted_36 = { class: "hidden xl:flex items-center justify-end gap-2" }
const _hoisted_37 = {
  key: 0,
  class: "ml-2 text-xs text-left sm:block"
}
const _hoisted_38 = { class: "block font-medium truncate" }
const _hoisted_39 = { class: "text-darkGray-4" }
const _hoisted_40 = { class: "bg-blue-4 min-h-[calc(100vh-4rem)] p-4 md:p-6 lg:p-8" }

import { useStore } from "vuex";
import { computed, onMounted, reactive, ref, watch } from "vue";

import { Profile } from "@/models/Profile";
import { navItems, isVisible, navItemClass } from "@/models/Navigation";
import { imageDoesExist } from "@/utils/getImages";
import { useRouter } from "vue-router";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import { Bars3Icon } from "@heroicons/vue/20/solid";
import "reflect-metadata";

import {
  Menu,
  MenuButton,
  MenuItems,
  MenuItem,
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import GeneralSearch from "@/features/shared/components/ui/GeneralSearch.vue";
import { TYPES } from "@/types";
import { myContainer } from "@/inversify.config";
import LinkButton from "@/features/shared/components/ui/LinkButton.vue";
import NotificationsView from "@/features/notifications/views/NotificationsView.vue";
import OdinAccessBanner from "@/features/admin/components/OdinAccessBanner.vue";
import { ISignalRService } from "@/interfaces/ISignalR";

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutDashboard',
  setup(__props) {

const store = useStore();
const signalRClient = myContainer.get<ISignalRService>(TYPES.ISignalRService);
const profile = ref({} as Profile);
const isLoaded = ref(false);
const router = useRouter();
const host = window.location.host;
const parts = host.split(".");
const subdomain = parts[0];
const isDevOrStaging =
  subdomain.includes("min-dev") || subdomain.includes("min-staging");

const toggleSidebar = () => {
  sidebarOpen.value = !sidebarOpen.value;
  const sidebar = document.querySelector(
    ".xl\\:fixed.xl\\:inset-y-0.xl\\:z-50.xl\\:flex.xl\\:w-72.xl\\:flex-col"
  );
  if (sidebar) {
    if (sidebarOpen.value) {
      sidebar.classList.remove("hidden");
    } else {
      sidebar.classList.add("hidden");
    }
  }
};

const onPickContainer = () => {
  store.dispatch("resetContainer");
  router.push("/admin/pick-container");
};

const onLogout = async () => {
  await store.dispatch("logout");
  router.push("/admin/login");
};

const onChangePassword = () => {
  router.push("/admin/change-password");
};

watch(
  () => store.getters.container.id,
  () => {
    init();
  }
);

watch(
  () => router.currentRoute.value.name,
  () => {
    sidebarOpen.value = false;
  }
);

const userIsWriter = ref(false);
const userIsAdmin = ref(false);
const userIsOdin = ref(false);
const profileHasLogo = ref(false);
const sidebarOpen = ref(false);

const roles = reactive({
  userIsWriter,
  userIsAdmin,
  userIsOdin,
});

onMounted(async () => {
  await store.dispatch("decodeToken");
  if (store.getters.container.id) {
    await store.dispatch("init");
  }

  // Load containers to show "Byt företag" button if user has multiple containers
  await store.dispatch("loadContainers");

  init();
});

const init = async () => {
  userIsAdmin.value = await store.dispatch("loggedInUserIsAdmin");
  userIsWriter.value = await store.dispatch("loggedInUserIsWriter");
  userIsOdin.value = await store.dispatch("loggedInUserIsOdin");
  profileHasLogo.value = await imageDoesExist(profile.value.Logo);
  isLoaded.value = true;
};

const navigateToLink = (link: string) => {
  if (isVisible(link, roles.userIsAdmin, roles.userIsWriter, store)) {
    // Navigera bara om länken är synlig och användbar
    router.push(link);
  }
};

const hasCategoryPermission = (category: any) => {
  // Adjust the condition based on your permission logic
  if (category.category === "Inställningar") {
    // Check if the user is a writer
    return userIsWriter.value;
  } else if (category.category === "Admin" && "Inställningar") {
    // Check if the user is an admin
    return userIsAdmin.value;
  } else if (category.category === "Admin" && "Inställningar" && "Superuser") {
    // Check if the user is an Odin
    return userIsOdin.value;
  } else {
    return true; // Default to true for other categories
  }
};

const showCategories02 = (categories: any[]): any[] => {
  return categories.filter((category) =>
    ["Allmänt", "Inställningar", "Admin"].includes(category.category)
  );
};
const showCategories03 = (categories: any[]): any[] => {
  return categories.filter((category) =>
    ["Allmänt", "Inställningar", "Admin", "Superuser"].includes(
      category.category
    )
  );
};

const categories02 = showCategories02(navItems);
const categories03 = showCategories03(navItems);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_notification_list = _resolveComponent("vue-notification-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[19] || (_cache[19] = _createElementVNode("link", {
      href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css",
      rel: "stylesheet"
    }, null, -1)),
    _createElementVNode("div", null, [
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: sidebarOpen.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-50 xl:hidden",
            onClose: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition-opacity ease-linear duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "transition-opacity ease-linear duration-300",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "fixed inset-0 bg-gray-900/80" }, null, -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "transition ease-in-out duration-300 transform",
                  "enter-from": "-translate-x-full",
                  "enter-to": "translate-x-0",
                  leave: "transition ease-in-out duration-300 transform",
                  "leave-from": "translate-x-0",
                  "leave-to": "-translate-x-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative flex w-full max-w-xs flex-1" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "-m-2.5 p-2.5",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
                          }, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)),
                            _createVNode(_unref(XMarkIcon), {
                              class: "h-6 w-6 text-gray-900",
                              "aria-hidden": "true"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_router_link, { to: "/admin" }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("img", {
                                  src: "/images/logo.svg",
                                  class: "h-8 w-auto"
                                }, null, -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          (userIsAdmin.value !== undefined && userIsWriter.value !== undefined)
                            ? (_openBlock(), _createElementBlock("nav", _hoisted_5, [
                                _withDirectives(_createVNode(LinkButton, {
                                  "style-type": "outline-complementary",
                                  icon: "plus",
                                  text: "Skapa annons",
                                  to: {
                      name: 'formbuilderPicker',
                    },
                                  class: "-mt-1 w-full h-[2.5em] flex place-content-center bg-gradient-to-b from-orange-2 to-orange-4 shadow-md shadow-gray-2 hover:shadow-lg text-lg transition duration-300 ease-in-out transform hover:scale-105 text-white"
                                }, null, 512), [
                                  [_vShow, userIsWriter.value || userIsAdmin.value || userIsOdin.value]
                                ]),
                                _withDirectives(_createElementVNode("button", _hoisted_6, [...(_cache[6] || (_cache[6] = [
                                  _createTextVNode("Skapa annons ", -1),
                                  _createElementVNode("i", { class: "fas fa-plus ml-2" }, null, -1)
                                ]))], 512), [
                                  [_vShow, !userIsWriter.value && !userIsAdmin.value && !userIsOdin.value]
                                ]),
                                _createElementVNode("ul", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(!userIsOdin.value
                        ? _unref(categories02)
                        : _unref(categories03), (category, i) => {
                                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                                      _createElementVNode("p", _hoisted_8, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass({
                            'text-stone-300': !hasCategoryPermission(category),
                          })
                                        }, [
                                          _createTextVNode(_toDisplayString(category.category) + " ", 1),
                                          (!hasCategoryPermission(category))
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                                            : _createCommentVNode("", true)
                                        ], 2)
                                      ]),
                                      _createElementVNode("ul", _hoisted_10, [
                                        (!userIsOdin.value ? _unref(categories02) : _unref(categories03))
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(category.items, (item) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: item.link,
                                                class: "px-3 py-1.5 rounded-md"
                                              }, [
                                                _createVNode(_component_router_link, {
                                                  to: item.link,
                                                  onClick: _withModifiers(($event: any) => (navigateToLink(item.link)), ["prevent"]),
                                                  class: _normalizeClass({
                              'text-stone-300 cursor-not-allowed': !_unref(isVisible)(
                                item.link,
                                userIsAdmin.value,
                                userIsWriter.value,
                                _unref(store)
                              ),
                              'bg-blue-4 text-blue-1':
                                _ctx.$route.fullPath === item.link, // Apply styling for the selected link
                              'text-darkGray-3 hover:bg-blue-4':
                                _ctx.$route.fullPath !== item.link, // Apply styling for other links
                            })
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_11, [
                                                      _createElementVNode("span", _hoisted_12, [
                                                        _createElementVNode("i", {
                                                          class: _normalizeClass([
                                    _unref(navItemClass)(item),
                                    'text-xl fas',
                                    item?.icon,
                                    {
                                      'text-stone-300': !_unref(isVisible)(
                                        item.link,
                                        userIsAdmin.value,
                                        userIsWriter.value,
                                        _unref(store)
                                      ),
                                    },
                                  ])
                                                        }, null, 2)
                                                      ]),
                                                      _createElementVNode("span", _hoisted_13, _toDisplayString(item.name), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to", "onClick", "class"])
                                              ]))
                                            }), 128))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("ul", _hoisted_14, [
                                  _createElementVNode("li", _hoisted_15, [
                                    (_unref(store).state.userStore.token !== null)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                                          _createElementVNode("strong", _hoisted_17, _toDisplayString(_unref(store).state.userStore.token?.decoded?.given_name) + " " + _toDisplayString(_unref(store).state.userStore.token?.decoded?.family_name) + " (" + _toDisplayString(_unref(store).getters.container?.name) + ")", 1),
                                          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(store).state.userStore.token?.decoded?.sub), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_19, [
                                      (_unref(store).getters.containers.length > 1)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: onPickContainer,
                                            class: "hover:text-gray-900",
                                            title: "Byt företag"
                                          }, [...(_cache[7] || (_cache[7] = [
                                            _createElementVNode("i", { class: "fas fa-building" }, null, -1)
                                          ]))]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("button", {
                                        onClick: onChangePassword,
                                        class: "ml-2 hover:text-gray-900",
                                        title: "Byt Lösenord"
                                      }, [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("i", { class: "fas fa-key" }, null, -1)
                                      ]))]),
                                      _createElementVNode("button", {
                                        onClick: onLogout,
                                        class: "ml-2 hover:text-gray-900",
                                        title: "Logga ut"
                                      }, [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)
                                      ]))])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_router_link, { to: "/admin" }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createElementVNode("img", {
                  src: "/images/logo.svg",
                  alt: "logo",
                  class: "h-8 w-auto"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          (userIsAdmin.value !== undefined && userIsWriter.value !== undefined)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_23, [
                _createElementVNode("div", null, [
                  _withDirectives(_createVNode(LinkButton, {
                    "style-type": "outline-complementary",
                    icon: "plus",
                    text: "Skapa annons",
                    to: {
                name: 'formbuilderPicker',
              },
                    class: "-mt-1 w-full h-[2.5em] mb-[1em] flex place-content-center bg-gradient-to-b from-orange-2 to-orange-4 shadow-md shadow-gray-2 hover:shadow-lg text-lg transition duration-300 ease-in-out transform hover:scale-105 text-white"
                  }, null, 512), [
                    [_vShow, userIsWriter.value || userIsAdmin.value || userIsOdin.value]
                  ]),
                  _withDirectives(_createElementVNode("button", _hoisted_24, [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Skapa annons ", -1),
                    _createElementVNode("i", { class: "fas fa-plus ml-2" }, null, -1)
                  ]))], 512), [
                    [_vShow, !userIsWriter.value && !userIsAdmin.value && !userIsOdin.value]
                  ])
                ]),
                _createElementVNode("ul", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(!userIsOdin.value ? _unref(categories02) : _unref(categories03), (category, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      _createElementVNode("p", _hoisted_26, [
                        _createElementVNode("span", {
                          class: _normalizeClass({
                    'text-stone-300': !hasCategoryPermission(category),
                  })
                        }, [
                          _createTextVNode(_toDisplayString(category.category) + " ", 1),
                          (!hasCategoryPermission(category))
                            ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _createElementVNode("ul", _hoisted_28, [
                        (!userIsOdin.value ? _unref(categories02) : _unref(categories03))
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(category.items, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item.link,
                                class: "px-3 py-1.5 rounded-md"
                              }, [
                                _createVNode(_component_router_link, {
                                  to: item.link,
                                  onClick: _withModifiers(($event: any) => (navigateToLink(item.link)), ["prevent"]),
                                  class: _normalizeClass({
                      'text-stone-300 cursor-not-allowed': !_unref(isVisible)(
                        item.link,
                        userIsAdmin.value,
                        userIsWriter.value,
                        _unref(store)
                      ),
                      'bg-blue-4 text-blue-1': _ctx.$route.fullPath === item.link,
                      'text-darkGray-3 hover:bg-blue-4':
                        _ctx.$route.fullPath !== item.link,
                    })
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("span", _hoisted_30, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass([
                            _unref(navItemClass)(item),
                            'text-xl fas',
                            item?.icon,
                            {
                              'text-stone-300': !_unref(isVisible)(
                                item.link,
                                userIsAdmin.value,
                                userIsWriter.value,
                                _unref(store)
                              ),
                            },
                          ])
                                        }, null, 2)
                                      ]),
                                      _createElementVNode("span", _hoisted_31, _toDisplayString(item.name), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to", "onClick", "class"])
                              ]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("button", {
            type: "button",
            class: "-m-2.5 p-2.5 text-gray-800 xl:hidden",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (sidebarOpen.value = true))
          }, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)),
            _createVNode(_unref(Bars3Icon), {
              class: "text-gray-500 h-5 w-5",
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(GeneralSearch)
          ]),
          (_unref(isDevOrStaging))
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("p", { class: "truncate" }, "Testmiljö - ej riktig data", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(NotificationsView),
            _createVNode(_unref(Menu), {
              as: "div",
              class: "relative"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_unref(MenuButton), { class: "flex items-center transition rounded-lg group shrink-0" }, {
                    default: _withCtx(() => [
                      (_unref(store).state.userStore.token !== null)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                            _createElementVNode("strong", _hoisted_38, _toDisplayString(_unref(store).state.userStore.token?.decoded?.given_name) + " " + _toDisplayString(_unref(store).state.userStore.token?.decoded?.family_name) + " (" + _toDisplayString(_unref(store).getters.container?.name) + ")", 1),
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(store).state.userStore.token?.decoded?.sub), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _cache[14] || (_cache[14] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "w-5 h-5 ml-2 text-darkGray-2 transition sm:block group-hover:text-darkGray-1",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                          "clip-rule": "evenodd"
                        })
                      ], -1))
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_Transition, {
                  "enter-active-class": "transition duration-100 ease-out",
                  "enter-from-class": "transform scale-95 opacity-0",
                  "enter-to-class": "transform scale-100 opacity-100",
                  "leave-active-class": "transition duration-75 ease-in",
                  "leave-from-class": "transform scale-100 opacity-100",
                  "leave-to-class": "transform scale-95 opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MenuItems), { class: "absolute right-0 mt-2 w-56 origin-top-right divide-y text-gray-600 divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(MenuItem), null, {
                          default: _withCtx(({ active }) => [
                            _createVNode(_component_router_link, {
                              to: "/admin/profile",
                              class: _normalizeClass([
                      active ? 'bg-gray-100 text-gray-900' : 'bg-white',
                      'group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6',
                    ])
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("div", {
                                  class: "h-6 w-6 shrink-0",
                                  "aria-hidden": "true"
                                }, [
                                  _createElementVNode("i", { class: "fas fa-user-cog" })
                                ], -1),
                                _createElementVNode("p", null, "Profilinställningar", -1)
                              ]))]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        }),
                        (_unref(store).getters.containers && _unref(store).getters.containers.length > 1)
                          ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 0 }, {
                              default: _withCtx(({ active }) => [
                                _createElementVNode("button", {
                                  onClick: onPickContainer,
                                  class: _normalizeClass([
                      active ? 'bg-gray-100 text-gray-900' : 'bg-white',
                      'group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6',
                    ])
                                }, [...(_cache[16] || (_cache[16] = [
                                  _createElementVNode("div", {
                                    class: "h-6 w-6 shrink-0",
                                    "aria-hidden": "true"
                                  }, [
                                    _createElementVNode("i", { class: "fas fa-building" })
                                  ], -1),
                                  _createElementVNode("p", null, "Byt företag", -1)
                                ]))], 2)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(MenuItem), null, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("button", {
                              onClick: onChangePassword,
                              class: _normalizeClass([
                      active ? 'bg-gray-100 text-gray-900' : 'bg-white',
                      'group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6',
                    ])
                            }, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("div", {
                                class: "h-6 w-6 shrink-0",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("i", { class: "fas fa-key" })
                              ], -1),
                              _createElementVNode("p", null, "Byt lösenord", -1)
                            ]))], 2)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(MenuItem), null, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("button", {
                              onClick: onLogout,
                              class: _normalizeClass([
                      active ? 'bg-gray-100 text-gray-900' : 'bg-white',
                      'group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6',
                    ])
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("div", {
                                class: "h-6 w-6 shrink-0",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("i", { class: "fas fa-sign-out-alt" })
                              ], -1),
                              _createElementVNode("p", null, "Logga ut", -1)
                            ]))], 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("main", _hoisted_40, [
          (userIsOdin.value)
            ? (_openBlock(), _createBlock(OdinAccessBanner, { key: 0 }))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_component_vue_notification_list, { position: "bottom-right" })
        ])
      ])
    ])
  ], 64))
}
}

})